
export const name = 'unitsFilter';
export default function unitsFilter($filter, templatesService, $log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let preferences = null;

  function unitsFilterLogic(value, originalUnits, addUnitsWord){

    if(value === undefined){
      return;
    }

    if((addUnitsWord === undefined) || (addUnitsWord == null)){
      addUnitsWord = false;
    }

    let units = (preferences==null || preferences.general == null || preferences.general.unitSystem == null) ? "Metric" : preferences.general.unitSystem;
    let returnValue = 'null';

    if(originalUnits === "points"){
      if(units === 'Metric'){
        // in this case translate to millimeters
        let translatedValue = (value /  72) * 25.4;

        returnValue = $filter('number')(translatedValue,3);

        returnValue += addUnitsWord === true ? ' mm' : '';

      }else if(units === 'Imperial'){
        // in this case translate to Inches
        let translatedValue = value / 72;

        returnValue = $filter('number')(translatedValue,4);

        returnValue += addUnitsWord === true ? ' in' : '';
      }

    }else{
      $log.error(angular.toJson({action: 'unitsFilter unsupported originalUnits',originalUnits: originalUnits}));

      returnValue = '' + value;

      if(addUnitsWord === true){
        returnValue += ' ' + originalUnits;
      }
    }

    return returnValue;

  }

  return function(value, originalUnits, addUnitsWord){
    if(preferences == null){
      templatesService.getUserPreferences().then(
        function(pref){
          preferences = pref;
          //return unitsFilterLogic(value, originalUnits, addUnitsWord);
          return "";
        },
        function(errorInfo){
          $log.error(angular.toJson({action: 'unitsFilter error reading preferences - using defaults',errorInfo: errorInfo}));
          return unitsFilterLogic(value, originalUnits, addUnitsWord);
        }
      );
    }


    return unitsFilterLogic(value, originalUnits, addUnitsWord);//unitsFilterLogic(value, originalUnits, addUnitsWord);

  };
}
